import React from 'react';
import EditarMotores from '../../../components/insumos/motores/EditarMotores';

const MotoresPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Editar Motores</h1>
      <br />
      <br />
      <EditarMotores />
    </div>
  );
};

export default MotoresPage;